/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import Loading from '../../components/loading';
import styles from './hazard_builder.module.scss';
import { isLocal, hostName } from '../../constants/apiEnv';

function SmsAirports(props) {
  const { intl } = props;
  const [loadData, handleLoading] = useState(false);
  const [airportsList, setAirportsList] = useState([]);
  const [airportData, setAirportData] = useState([]);
  const [smsForm, setSmsForm] = useState(null);
  const urlParams = useParams();

  useEffect(() => {
    if (!airportsList.length) {
        getAirportInfo();
    }
  });

  useEffect(() => {
    if (!smsForm) {
        getSMSForm();
    }
  });

  const getAirportInfo = async () => {
    try {
      const url = hostName.slice(6);
      const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${urlParams?.id || 'us'}${url}/public`;
      handleLoading(true);
      await fetch(`${publicUrl}/airfield/data/${urlParams.airportCode.toUpperCase()}`)
        .then(response => response.json())
        .then((data) => {
            setAirportData(data);
            setAirportsList(data.child_airports);
            handleLoading(false);
        });
    } catch (error) {
      // nothing
    }
  };

  const getSMSForm = async () => {
    const url = hostName.slice(6);
    const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${urlParams?.id || 'us'}${url}/public`;
    handleLoading(true);
    await fetch(`${publicUrl}/safety_management/get_schema/${urlParams.airportCode.toUpperCase()}`)
        .then(response => response.json())
        .then((data) => {
            setSmsForm(data);
            handleLoading(false);
        });
  };

  const goToForm = (airport) => {
    const { history } = props;
    if (airport?.code !== undefined) {
      history.push(`/safety_management/${urlParams?.id || 'us'}/${airport.code.toUpperCase()}`);
    }
  };

  const smsValues = {
    activity_title: 'Comments',
    correctiveaction_title: 'Mitigations',
    hazard_title: 'Safety Hazard',
    riskacceptance_title: 'Risk Acceptance',
    subhazard_title: 'Sub-Hazard'
  };
  const nomenclature = smsForm?.public_form_settings?.nomenclature || smsValues;

  return (
    <>
        <Loading loadingStatus={loadData} />
        <div className={styles.Image}>
            <img src={airportData?.airport_logo} alt="airport_logo" />
        </div>
        <div className={`${styles.container}`}>
            <div className={styles.box}>
                <div className={styles.title}>
                    <FormattedMessage
                        id="sms.hazard.report.custom"
                        values={{ title: intl.formatMessage({ id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
                        defaultMessage: nomenclature?.hazard_title || 'Safety Hazard' }) }}
                        defaultMessage={`Report ${nomenclature?.hazard_title}`}
                    />
                </div>
                <div className={styles.airports_list}>
                    <div className={styles.airports_list__airport_container}>
                    { airportsList.map(airport => (
                        <div
                            tabIndex="0"
                            key={airport.id}
                            role="button"
                            className={styles.airports_list__airport}
                        >
                            <div>
                            <img src={airport.logo} alt="Airport Logo" />
                            <span>{airport.name}</span>
                            </div>
                            <div>
                                <span
                                  onClick={() => goToForm(airport)}
                                  style={{ color: '#007bff' }}
                                >
                                    <FormattedMessage
                                        id="sms.hazard.report"
                                        defaultMessage="Report"
                                    />
                                </span>
                            </div>
                        </div>
                        ))
                    }
                    </div>
                </div>
            </div>
            <span className={styles.Link}>
                <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer">
                <FormattedMessage
                id="sms.hazard.poweredBy"
                defaultMessage="Powered by Aerosimple" />
                </a>
            </span>
        </div>
    </>
  );
}

export default injectIntl(SmsAirports);
